import styled from 'styled-components'

export const CityPlansTableLinks = styled.div`
  display: block;
  float: right;

  a {
    display: block;
    float: left;

    svg {
      margin: 0;
    }
  }

  a:not(:last-child) {
    margin-right: 20px;
  }
`
